var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6568 9.26323C15.4276 9.48376 15.1202 9.60426 14.8022 9.59826C14.4842 9.59226 14.1815 9.46025 13.9608 9.23123L8.02482 2.93043L2.08882 9.23123C1.98092 9.35018 1.85024 9.44626 1.70453 9.51379C1.55881 9.58131 1.40103 9.61889 1.24052 9.62432C1.08002 9.62974 0.920054 9.60289 0.770115 9.54536C0.620177 9.48783 0.483311 9.40078 0.36763 9.28938C0.251948 9.17799 0.159804 9.0445 0.0966566 8.89684C0.0335095 8.74918 0.000644296 8.59034 8.9165e-06 8.42975C-0.000626463 8.26915 0.0309811 8.11006 0.0929578 7.9619C0.154935 7.81375 0.24602 7.67954 0.360817 7.56723L7.16082 0.367229C7.27276 0.25109 7.40696 0.158713 7.55541 0.095616C7.70386 0.0325191 7.86351 -1.6693e-06 8.02482 -1.6693e-06C8.18612 -1.6693e-06 8.34577 0.0325191 8.49422 0.095616C8.64267 0.158713 8.77688 0.25109 8.88882 0.367229L15.6888 7.56723C15.9093 7.79644 16.0298 8.10383 16.0238 8.42185C16.0178 8.73987 15.8858 9.0425 15.6568 9.26323Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuUp);
export default __webpack_public_path__ + "static/media/menu-up.6c8d60ad27133c28a0692251a4785571.svg";
export { ForwardRef as ReactComponent };